import svgUrl from "ni:svgr;GzFvUFjTelcqVwaz3nNM5muyISHrRQh6T0Kr3svrPvs";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiSplitColumnsSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M5.5 2a.5.5 0 0 0-.5.5V6h1V3h1.5v4H2.707l1.147-1.146a.5.5 0 1 0-.708-.708l-2 2a.5.5 0 0 0 0 .708l2 2a.5.5 0 0 0 .708-.708L2.707 8H7.5v5H6V9H5v4.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V9h-1v4H8.5V8h4.793l-1.147 1.146a.5.5 0 0 0 .708.708l2-2a.5.5 0 0 0 0-.708l-2-2a.5.5 0 0 0-.708.708L13.293 7H8.5V3H10v3h1V2.5a.5.5 0 0 0-.5-.5h-5Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiSplitColumnsSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiSplitColumnsSIcon)";
}